export function alertErrorTwoButton(alertRepository, text) {
    alertRepository.SweetTwoButton('Error', text, 'error')
}